import { DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI } from '../../../types/default-cloud-graph-document-entity-ati';
import { type ThirdPartyConfig } from '../../../types/schemas/types';
import { TypeFilterValueKey } from '../../../utils/filters/universalType';
import { get3PLogo } from '../../icons';
import { ProductResourceTypes3P } from '../types';

import { ForgeUtoolityGitbookIcon, ForgeUtoolityGitbookSearchResultIcon } from './icon';

export const forgeUtoolityGitbookConfig: ThirdPartyConfig = {
	displayName: 'Gitbook - by Utoolity',
	id: 'forge-connector-FEJ0dhTb8HC3UYmqhPAKYCWVTcpoHsp5-gitbook-connector',
	resourceType: ProductResourceTypes3P.ForgeUtoolityGitbookDev,
	icon: get3PLogo(ForgeUtoolityGitbookIcon, 'ForgeUtoolityGitbook', 'medium'),
	searchResultIcon: get3PLogo(
		ForgeUtoolityGitbookSearchResultIcon,
		'ForgeUtoolityGitbook',
		'large',
	),
	integrationAri: 'ari:cloud:platform::integration/FEJ0dhTb8HC3UYmqhPAKYCWVTcpoHsp5',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.Document,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
				subTypes3P: [],
			},
		],
	]),
	filters: ['lastUpdated'],
	requiresOauth: false,
	isEnabled: () => true,
	displayWorkspaceNameAsProductName: true,
};
